import React, { useState } from "react";

import classNames from "classnames";
import PropTypes from "prop-types";
import Container from "react-bootstrap/Container";
import { Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/scss";
import "swiper/scss/navigation";

import "./subNavigation.scss";

const SubNavigation = ({
  items,
  alignLeft = false,
  className = undefined,
  sspNavigation = false,
}) => {
  const [swiper, setSwiper] = useState(null);
  const [nextDisabled, setNextDisabled] = useState(true);
  const [prevDisabled, setPrevDisabled] = useState(true);

  const updateSwiperControlls = () => {
    if (swiper) {
      setNextDisabled(swiper.isEnd);
      setPrevDisabled(swiper.isBeginning);
    }
  };

  const focusSlide = () => {
    if (swiper) {
      const i = swiper.slides.findIndex((slide) => (
        slide.childNodes[0].classList.contains("active")
      ));

      if (i > 0 && i < swiper.slidesGrid.length) {
        swiper.clickedIndex = i;
        swiper.slideTo(i, 300);
        swiper.translateTo(
          (swiper.slidesGrid[i]
            - (window.innerWidth / 2)
            + (swiper.slidesSizesGrid[i] / 2)) * -1,
          300,
        );
      }

      updateSwiperControlls();
    }
  };

  const initSwiper = () => {
    if (swiper) {
      setTimeout(() => {
        swiper.update();
        focusSlide();
      }, 500);
    }
  };

  return (
    <div className={classNames("sub-navigation__wrapper container--fullwidth", { "d-none d-lg-block": !sspNavigation })}>
      <Container fluid>
        <div className={classNames("sub-navigation container-md-down--fullwidth", className)}>
          <Swiper
            breakpoints={{
              0: {
                allowTouchMove: true,
                spaceBetween: 24,
              },
              992: {
                allowTouchMove: false,
                spaceBetween: 24,
              },
              1200: {
                allowTouchMove: false,
                spaceBetween: 30,
              },
            }}
            centerInsufficientSlides={!alignLeft}
            centeredSlidesBounds
            freeMode
            modules={[Navigation]}
            mousewheel={{ forceToAxis: true, invert: true }}
            onResize={focusSlide}
            onSetTranslate={updateSwiperControlls}
            onSwiper={setSwiper}
            onAfterInit={initSwiper}
            slidesPerView="auto"
          >
            {items.map((item) => <SwiperSlide key={item.key}>{() => item}</SwiperSlide>)}
          </Swiper>

          <button
            className={classNames(
              "swiper-button-prev",
              { "swiper-button-disabled": prevDisabled },
            )}
            onClick={() => {
              swiper.slidePrev();
            }}
            type="button"
            aria-label="Prev"
          />

          <button
            className={classNames(
              "swiper-button-next",
              { "swiper-button-disabled": nextDisabled },
            )}
            onClick={() => {
              swiper.slideNext();
            }}
            type="button"
            aria-label="Next"
          />
        </div>
      </Container>
    </div>
  );
};

SubNavigation.propTypes = {
  alignLeft: PropTypes.bool,
  className: PropTypes.string,
  items: PropTypes.oneOfType([PropTypes.array]).isRequired,
  sspNavigation: PropTypes.bool,
};

export default SubNavigation;
